"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRIP_TYPE = exports.TRIP_DATE_FORMATS = exports.TEXT_TYPE = exports.PASSENGER_TYPES = exports.PASSENGER_TERMS = exports.KEY_CODE = exports.ICON_TYPES = exports.ICON_SIZE = exports.DAYS_OF_THE_WEEK = exports.DATE_LABEL = exports.BUTTON_FUNC = void 0;
var TRIP_TYPE = {
  ROUNDTRIP: 'R',
  ONEWAY: 'O'
};
exports.TRIP_TYPE = TRIP_TYPE;
var ICON_TYPES = {
  ROUNDTRIP_ICON: 'SwapHorizIcon',
  ONEWAY_ICON: 'ArrowRightAltIcon',
  CHANGE_CURRENCY: 'ChangeCurrency',
  DOT_ICON: 'FiberManualRecordIcon',
  BACK_ICON: 'ArrowBackIcon',
  REMOVE_ICON: 'RemoveIcon',
  FLIGHT_ICON: 'FlightIcon',
  SYNC_ALT: 'SyncAlt'
};
exports.ICON_TYPES = ICON_TYPES;
var PASSENGER_TYPES = {
  oneAdult: 'adult',
  manyAdults: 'adults',
  combination: 'guests'
};
exports.PASSENGER_TYPES = PASSENGER_TYPES;
var PASSENGER_TERMS = {
  guests: 'Guests',
  adult: 'Adult',
  adults: 'Adults'
};
exports.PASSENGER_TERMS = PASSENGER_TERMS;
var TEXT_TYPE = {
  default: {
    type: 'default',
    size: 'normal',
    color: 'neutral',
    otaColor: 'secondaryBlue',
    bold: 'bold'
  },
  small: {
    type: 'small',
    size: 'XSmall',
    color: 'greyDark',
    otaColor: 'secondaryBlue'
  },
  textSmall: {
    type: 'textSmall',
    size: 'small',
    color: 'greyDark',
    otaColor: 'secondaryBlue'
  },
  superSmall: {
    type: 'small',
    size: 'XXSmall',
    color: 'greyDark',
    otaColor: 'secondaryBlue'
  },
  title: {
    type: 'default',
    size: 'normal',
    color: 'greyDark',
    otaColor: 'secondaryBlue'
  },
  sub: {
    type: 'sub',
    size: 'small',
    color: 'neutral',
    otaColor: 'secondaryBlue'
  },
  large: {
    type: 'titleLarge',
    size: 'large',
    color: 'black',
    otaColor: 'secondaryBlue',
    bold: 'semiLarge'
  },
  medium: {
    type: 'medium',
    size: 'large',
    color: 'black',
    otaColor: 'secondaryBlue',
    bold: 'semiLarge'
  },
  titleNormal: {
    type: 'titleNormal',
    size: 'large',
    color: 'black',
    otaColor: 'secondaryBlue',
    bold: 'semiLarge'
  }
};
exports.TEXT_TYPE = TEXT_TYPE;
var TRIP_DATE_FORMATS = {
  // SHORT: 'Simple Day',
  // COMPLETE: 'Short Simple Date',
  SHORT: 'Short Simple Date',
  COMPLETE: 'Short Full Simple Date',
  FLIGHT_INFO_SHORT: 'Simple Day',
  FLIGHT_INFO_COMPLETE: 'Complete Full Day',
  OTA_FLIGHT_FORMAT: 'OTA Date Format'
};
exports.TRIP_DATE_FORMATS = TRIP_DATE_FORMATS;
var BUTTON_FUNC = {
  edit: 'edit',
  back: 'back'
};
exports.BUTTON_FUNC = BUTTON_FUNC;
var KEY_CODE = {
  ENTER: 13,
  ESC: 27
};
exports.KEY_CODE = KEY_CODE;
var DATE_LABEL = {
  departure: 'Depart: ',
  return: 'Return: ',
  Sunday: 'Sun',
  Saturday: 'Sat',
  Monday: 'Mon',
  Tuesday: 'Tues',
  Wednesday: 'Wed',
  Thursday: 'Thurs',
  Friday: 'Fri'
};
exports.DATE_LABEL = DATE_LABEL;
var ICON_SIZE = {
  mini: '1rem !important',
  large: '1.5rem !important'
};
exports.ICON_SIZE = ICON_SIZE;
var DAYS_OF_THE_WEEK = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
exports.DAYS_OF_THE_WEEK = DAYS_OF_THE_WEEK;